import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogProps,
  SvgIcon,
  Box,
  Typography,
  TextField,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Divider,
  IconButton
} from '@mui/material';
import TextImput from '../text-imput';
import Buttons from '../button';

interface GenericModalProps extends Omit<DialogProps, 'content'> {
  open: boolean; // Controle de visibilidade do modal
  starticon?: React.ReactNode; // Ícone no começo do modal
  title?: string; // Título do modal
  content?: React.ReactNode; // Conteúdo do modal
  actions?: React.ReactNode; // Botões
  onClose: () => void; // Função para fechar o modal
  type: string;// Tipo de modal que vai renderizar
}

const GenericModal: React.FC<GenericModalProps> = ({
  open,
  title,
  content,
  actions,
  onClose,
  starticon,
  type,
  ...dialogProps
}) => {

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
  };

  const [selectedAnalysis, setSelectedAnalysis] = useState<string[]>([]);
  const analysisOptions = [
    { label: 'Básico (resina)', description: 'pH CaCl2, P resina, K (NH4Cl), Ca(NH4Cl), Mg(NH4Cl), H + Al, CTC, V%, SB, Relações, Al, m%' },
    { label: 'Completo sem física (resina)', description: 'pH CaCl2, P resina, K (NH4Cl), Ca(NH4Cl), Mg(NH4Cl), H + Al, CTC, V%, SB, Relações, Al, m%' },
    { label: 'Completo com física (resina)', description: 'pH CaCl2, P resina, K (NH4Cl), Ca(NH4Cl), Mg(NH4Cl), H + Al, CTC, V%, SB, Relações, Al, m%' },
    { label: 'Básico (melich)', description: 'pH CaCl2, P resina, K (NH4Cl), Ca(NH4Cl), Mg(NH4Cl), H + Al, CTC, V%, SB, Relações, Al, m%' },
    { label: 'Completo sem física (melich)', description: 'pH CaCl2, P resina, K (NH4Cl), Ca(NH4Cl), Mg(NH4Cl), H + Al, CTC, V%, SB, Relações, Al, m%' },
    { label: 'Granulomérica (método da pipeta)', description: 'pH CaCl2, P resina, K (NH4Cl), Ca(NH4Cl), Mg(NH4Cl), H + Al, CTC, V%, SB, Relações, Al, m%' },
  ];

  const additionalOptions = [
    "Granulométrica (Peneiras 10, 20 e 50) + Umidade",
    "Só Umidade",
    "Cálcio (Ca)",
    "Magnésio (Mg)",
    "Cádmio (Cd)",
    "Chumbo (Pb)",
    "Cromo (Cr)",
    "Níquel (Ni)",
    "Monóxido de carbono (Co)",
    "Enxofre (S)",
  ];

  const handleCheckboxChange = (label: string) => {
    setSelectedAnalysis((prev) =>
      prev.includes(label)
        ? prev.filter((item) => item !== label)
        : [...prev, label]
    );
  };

  const handleSave = () => {
    // Lógica para salvar as alterações
    console.log('Análises selecionadas:', selectedAnalysis);
    onClose();
  };

  const [value, setValue] = React.useState('');

  return (
    <>
    {(type === "success" && <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          minHeight: '279px',
          minWidth: '500px',
          borderRadius: '12px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '16px',
        },
      }}
      {...dialogProps}
    >
      {starticon && (
        <SvgIcon
          sx={{
            fontSize: '64px',
            color: '#25272E',
            marginBottom: '16px',
            textAlign: 'center',
          }}
        >
          {starticon}
        </SvgIcon>
      )}
      {title && (
        <DialogTitle
          sx={{
            fontSize: '22px',
            color: '#25272E',
            fontWeight: '700',
            textAlign: 'center',
            marginBottom: '8px',
          }}
        >
          {title}
        </DialogTitle>
      )}
      {content && (
        <DialogContent
          sx={{
            textAlign: 'center',
            marginBottom: '16px',
          }}
        >
          {content}
        </DialogContent>
      )}
      {actions && (
        <DialogActions
          sx={{
            display: 'flex',
            justifyContent: 'center',
            gap: '8px',
          }}
        >
          {actions}
        </DialogActions>
      )}
    </Dialog>)}

    {type === "edit" && (
      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            maxHeight: '90vh', 
            overflowY: 'auto',
            minHeight: "100vh",
            minWidth: "900px",
            borderRadius: "12px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          },
        }}
        {...dialogProps}
      >
        <Box
          sx={{
            width: '100%',
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            p: 4,
            borderRadius: 2,
            maxHeight: '90vh', 
            overflowY: 'auto'
          }}
        >
          <Typography variant="h6" component="h2" sx={{ color:'var(--primary-color)', marginTop:'-4%' }}>
            Editar Amostra
          </Typography>
          <IconButton 
            onClick={onClose} 
            sx={{ position: 'absolute', top: -3, right: 20 }}
          >
            <SvgIcon>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.6 4.40002L4.40002 11.6M11.6 11.6L4.40002 4.40002" stroke="#294732" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </SvgIcon>
          </IconButton>
          <Divider sx={{ backgroundColor: '#CDD2D9', my: 2 }} />
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 2,
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ flex: "0 0 100%" }}>
              <TextField
                select
                label="Escolha uma opção"
                value={value}
                onChange={handleChange}
                fullWidth>
                <MenuItem value="option1">Solo</MenuItem>
                <MenuItem value="option2">Foliar</MenuItem>
              </TextField>
            </Box>
            <Box sx={{ flex: "0 0 100%" }}>
              <TextImput
                label="Fazenda"
                placeholder="Nome da Fazenda"
                type="text"
              />
            </Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
              <TextField
                label="Fazenda"
                placeholder="Nome da Fazenda"
                sx={{ flex: '1 1 calc(25% - 16px)' }}
              />
              <TextField
                label="Cultura"
                placeholder="Café"
                sx={{ flex: '1 1 calc(25% - 16px)' }}
              />
              <TextField
                label="Identificação"
                placeholder="T.01"
                sx={{ flex: '1 1 calc(25% - 16px)' }}
              />
              <TextField
                label="Profundidade"
                placeholder="0-20"
                sx={{ flex: '1 1 calc(25% - 16px)' }}
              />
            </Box>
          </Box>
          
          <Box sx={{ mt: 2, width: '100%'}}>
            {analysisOptions.map((option) => (
              <FormControlLabel  
                key={option.label}
                control={
                  <Checkbox
                    checked={selectedAnalysis.includes(option.label)}
                    onChange={() => handleCheckboxChange(option.label)}
                    sx={{
                      color: 'gray', 
                      '&.Mui-checked': {
                        color: 'var(--primary-color)',
                      },
                    }}
                  />
                }
                label={
                  <Box>
                    <Typography variant="body1">{option.label}</Typography>
                    <Typography variant="body2" color="text.secondary">
                      {option.description}
                    </Typography>
                  </Box>
                }
                sx={{ mb: 3, display: 'flex', flexDirection: 'row', width: '100%' }}
              />
            ))}
          </Box>

          <Box sx={{ width: '100%', mt: 2,border: '2px solid',
              borderColor: '#CDD2D9', 
              borderRadius: '8px', 
              padding: '12px' }}>
            <Typography sx={{ mb: 2, fontSize:'16px', fontWeight:'700' }}>
              ADICIONAIS
            </Typography>
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)', 
                gap: 0.5, 
              }}
            >
              {additionalOptions.map((option, index) => (
                <FormControlLabel
                  key={index}
                  control={<Checkbox sx={{
                    color: 'gray', 
                    '&.Mui-checked': {
                      color: 'var(--primary-color)',
                    },
                  }} />}
                  label={option}
                  sx={{ alignItems: 'center', fontSize:'10px', color:'text.secondary' }}
                />
              ))}
            </Box>
          </Box>
          
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2, gap:2 }}>
            <Buttons
              label="Cancelar"
              onClick={onClose}
              backgroundColor="#fff"
              borderColor="#ffff"
              textColor="var(--primary-color)"
              sx={{ width: '100px', 
                boxShadow: 'none'
              }}
            />
            <Buttons
              label="Salvar"
              onClick={handleSave}
              backgroundColor="var(--primary-color)"
              textColor="#fff"
              fullWidth = {false}
              sx={{
                  width:'148px',
                  boxShadow: 'none'}}
            />
          </Box>
        </Box>
      </Dialog>
    )}

    </>
  );
};

export default GenericModal;
